function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var shared = require('./shared');
var HASH_PATTERN = /^[a-f0-9]{64}$/;
function signed(reason) {
  return Object.freeze({
    state: 'signed',
    blockId: null,
    blockHash: null,
    confirmations: 0,
    reason: reason
  });
}
function normalizeBlockId(value) {
  if (typeof value === 'bigint') {
    if (value < 0n || value > BigInt(Number.MAX_SAFE_INTEGER)) return null;
    return Number(value);
  }
  return Number.isSafeInteger(value) && value >= 0 ? value : null;
}
function transactionMessage(transaction) {
  if (!transaction || _typeof(transaction) !== 'object') return null;
  try {
    if (typeof transaction.returnMessage === 'function') {
      return transaction.returnMessage();
    }
  } catch (error) {
    return null;
  }
  return transaction.msg;
}
function isMatchingScoreTransaction(transaction, transactionSignature, fingerprint) {
  if (!transaction || transaction.signature !== transactionSignature) return false;
  var message = transactionMessage(transaction);
  return Boolean(message && message.module === 'Snake' && message.request === 'snake score' && message.data && message.data.version === 2 && shared.createScoreData(message.data) && message.data.fingerprint === fingerprint);
}
function resolveCanonicalReceipt(_x, _x2) {
  return _resolveCanonicalReceipt.apply(this, arguments);
}
function _resolveCanonicalReceipt() {
  _resolveCanonicalReceipt = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(blockchain, request) {
    var fingerprint, transactionSignature, blockId, blockHash, canonicalHash, canonicalBlock, returnedBlockId, returnedBlockHash, transactions, transactionFound, latestBlockId, confirmations, _t, _t2, _t3, _t4, _t5, _t6;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          fingerprint = request && request.fingerprint;
          transactionSignature = request && request.transactionSignature;
          blockId = normalizeBlockId(request && request.blockId);
          blockHash = request && request.blockHash;
          if (!(!blockchain || typeof blockchain.getLongestChainHashAtId !== 'function' || typeof blockchain.getBlock !== 'function' || typeof blockchain.getLatestBlockId !== 'function' || typeof fingerprint !== 'string' || !HASH_PATTERN.test(fingerprint) || typeof transactionSignature !== 'string' || transactionSignature.length < 1 || transactionSignature.length > 256 || blockId === null || typeof blockHash !== 'string' || !HASH_PATTERN.test(blockHash))) {
            _context.n = 1;
            break;
          }
          return _context.a(2, signed('invalid'));
        case 1:
          _context.p = 1;
          _context.n = 2;
          return blockchain.getLongestChainHashAtId(BigInt(blockId));
        case 2:
          canonicalHash = _context.v;
          _context.n = 4;
          break;
        case 3:
          _context.p = 3;
          _t = _context.v;
          return _context.a(2, signed('chain_unavailable'));
        case 4:
          if (!(typeof canonicalHash !== 'string' || !HASH_PATTERN.test(canonicalHash))) {
            _context.n = 5;
            break;
          }
          return _context.a(2, signed('chain_unavailable'));
        case 5:
          _context.p = 5;
          _context.n = 6;
          return blockchain.getBlock(canonicalHash, true);
        case 6:
          canonicalBlock = _context.v;
          _context.n = 8;
          break;
        case 7:
          _context.p = 7;
          _t2 = _context.v;
          return _context.a(2, signed('block_unavailable'));
        case 8:
          if (canonicalBlock) {
            _context.n = 9;
            break;
          }
          return _context.a(2, signed('block_unavailable'));
        case 9:
          _context.p = 9;
          returnedBlockId = normalizeBlockId(canonicalBlock.id);
          returnedBlockHash = canonicalBlock.hash;
          transactions = canonicalBlock.transactions;
          _context.n = 11;
          break;
        case 10:
          _context.p = 10;
          _t3 = _context.v;
          return _context.a(2, signed('block_unavailable'));
        case 11:
          if (!(returnedBlockId !== blockId || returnedBlockHash !== canonicalHash || !Array.isArray(transactions))) {
            _context.n = 12;
            break;
          }
          return _context.a(2, signed('invalid'));
        case 12:
          _context.p = 12;
          transactionFound = transactions.some(function (transaction) {
            return isMatchingScoreTransaction(transaction, transactionSignature, fingerprint);
          });
          _context.n = 14;
          break;
        case 13:
          _context.p = 13;
          _t4 = _context.v;
          return _context.a(2, signed('invalid'));
        case 14:
          if (transactionFound) {
            _context.n = 15;
            break;
          }
          return _context.a(2, signed(canonicalHash === blockHash ? 'transaction_missing' : 'noncanonical'));
        case 15:
          _context.p = 15;
          _t5 = normalizeBlockId;
          _context.n = 16;
          return blockchain.getLatestBlockId();
        case 16:
          latestBlockId = _t5(_context.v);
          _context.n = 18;
          break;
        case 17:
          _context.p = 17;
          _t6 = _context.v;
          return _context.a(2, signed('chain_unavailable'));
        case 18:
          if (!(latestBlockId === null || latestBlockId < blockId)) {
            _context.n = 19;
            break;
          }
          return _context.a(2, signed('invalid'));
        case 19:
          confirmations = BigInt(latestBlockId) - BigInt(blockId) + 1n;
          if (!(confirmations > BigInt(Number.MAX_SAFE_INTEGER))) {
            _context.n = 20;
            break;
          }
          return _context.a(2, signed('invalid'));
        case 20:
          return _context.a(2, Object.freeze({
            state: 'observed',
            blockId: blockId,
            blockHash: canonicalHash,
            confirmations: Number(confirmations),
            reason: 'canonical'
          }));
      }
    }, _callee, null, [[15, 17], [12, 13], [9, 10], [5, 7], [1, 3]]);
  }));
  return _resolveCanonicalReceipt.apply(this, arguments);
}
function resolveCanonicalCallback(_x3, _x4, _x5) {
  return _resolveCanonicalCallback.apply(this, arguments);
}
function _resolveCanonicalCallback() {
  _resolveCanonicalCallback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(blockchain, block, request) {
    var blockId, blockHash, transactionFound, resolution, _t7;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          blockId = normalizeBlockId(block && block.id);
          blockHash = block && block.hash;
          if (!(blockId === null || blockId !== normalizeBlockId(request && request.blockId) || typeof blockHash !== 'string' || blockHash !== (request && request.blockHash) || !Array.isArray(block.transactions))) {
            _context2.n = 1;
            break;
          }
          return _context2.a(2, signed('invalid'));
        case 1:
          _context2.p = 1;
          transactionFound = block.transactions.some(function (transaction) {
            return isMatchingScoreTransaction(transaction, request && request.transactionSignature, request && request.fingerprint);
          });
          _context2.n = 3;
          break;
        case 2:
          _context2.p = 2;
          _t7 = _context2.v;
          return _context2.a(2, signed('invalid'));
        case 3:
          if (transactionFound) {
            _context2.n = 4;
            break;
          }
          return _context2.a(2, signed('transaction_missing'));
        case 4:
          _context2.n = 5;
          return resolveCanonicalReceipt(blockchain, request);
        case 5:
          resolution = _context2.v;
          if (!(resolution.state === 'observed' && resolution.blockHash !== blockHash)) {
            _context2.n = 6;
            break;
          }
          return _context2.a(2, signed('noncanonical'));
        case 6:
          return _context2.a(2, resolution);
      }
    }, _callee2, null, [[1, 2]]);
  }));
  return _resolveCanonicalCallback.apply(this, arguments);
}
module.exports = {
  resolveCanonicalCallback: resolveCanonicalCallback,
  resolveCanonicalReceipt: resolveCanonicalReceipt
};